











































































































import { Component, Vue } from 'vue-property-decorator';
import { ObjectFactory } from '../../config/objectFactory';
import { ApiRequest, AddDispatcherRequest } from '../../types/request';
import { validationMixin } from 'vuelidate';
import { required, minLength, email } from 'vuelidate/lib/validators';
import { MapUtils } from '../../util/mapUtils';
import { MedTransGoConstants } from '../../util/constants';
import { ToastEvent } from '../../types/event';
import { CommonUtils } from '../../util/commonUtils';
import { EventBus } from '../../main';
import { Dispatcher, ServiceRequest } from '../../types/entity';
import { DateUtils } from '@/util/dateUtils';
import { ModelSelect } from 'vue-search-select';
// tslint:disable-next-line: no-var-requires
const TimeZones = require('../../config/timezones.json');
declare var google: any;

@Component({
    mixins: [validationMixin],
    props: {
        transportId: String,
    },
    components: {
        ModelSelect,
    },
    data() {
        return {
            fullName: '',
            phone: '',
            email: '',
            timezone: '',
            address: {
                fullAddress: '',
                locality: '',
                state: '',
                city: '',
                zip: '',
            },
        };
    },
    validations: {
        fullName: {
            required,
            regex: (fullName) => /^[a-zA-Z ]+$/.test(fullName),
        },
        phone: {
            required,
            minLength: minLength(10),
            regex: (phone) => MedTransGoConstants.PHONE_REGX.test(phone),
        },
        email: {
            email,
            required,
        },
        timezone: {},
        address: {
            fullAddress: {
                required,
            },
            locality: {},
            state: {
                required,
            },
            city: {
                required,
            },
            zip: {
                required,
            },
        },
    },
})

export default class AddUserModal extends Vue {
    private locationGoogleAddress: any;
    private show = true;
    private addDispatcherRequest: AddDispatcherRequest | any;
    private TimeZones = TimeZones;
    public mounted() {
        this.$data.options = [];
        this.getGoogleAddress();
    }

    /**
     * @author <Aniket.P>
     * @description - google places
     * @param req {Request} - Express Request
     * @param res {Response} - Express Response - google places suggession
     * @returns google places suggession
     * @throws InvalidRequestException if network error
     */
    private async getGoogleAddress() {
        this.$root.$on('bv::modal::shown', (bvEvent: any, modalId: any) => {
            this.locationGoogleAddress = new google.maps.places.Autocomplete(
                document.getElementById('userAddress'), {
                types: ['geocode'],
            },
            );
            this.locationGoogleAddress.addListener('place_changed', () => {
                this.$data.address = MapUtils.parseGoogleAddress(this.locationGoogleAddress);
            });
        });
    }

    private async addDispatcher() {
        const iHttpService = ObjectFactory.getHttpService();
        const addDispatcherRequest: AddDispatcherRequest = {
            fullName: this.$data.fullName,
            email: this.$data.email,
            phone: this.$data.phone,
            address: this.$data.address,
            timezone: this.$data.timezone,
        };
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_TRANSPORTERS}/dispatcher/add`,
            data: addDispatcherRequest,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post<Dispatcher>(apiRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: 'User has been Added successfully',
                title: 'Success!',
                timeout: 2000,
                varient: 'success',
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.$emit('success');
            this.close();
        } else {
            CommonUtils.showError(response);
        }
    }

    private close() {
        if (this.$route.path === `${MedTransGoConstants.URL_SETTING}/${MedTransGoConstants.URL_ADD_USER}`) {
            this.$router.push({
                name: MedTransGoConstants.VIEW_SETTING_NAME,
            });
        } else {
            this.$emit('close');
        }
    }

    private getTimezoneRequests(result: ServiceRequest[]) {
        result.forEach((element: any) => {
            const appointmentTimestamp =
                DateUtils.convertToUTCInMillis(element.transporterProfile.appointmentDate + ' ' +
                    element.transporterProfile.appointmentTime, element.appointment.timezone);
            const appointmentTime = DateUtils.formatDate(appointmentTimestamp,
                DateUtils.FORMAT_DATETIME_AM_PM, element.appointment.timezone);
            element.transporterProfile.appointmentDate = appointmentTime;
            element.appointment.timestamp =
                DateUtils.formatDate(element.appointment.timestamp, DateUtils.FORMAT_DATETIME_AM_PM);
            element.createdOn = DateUtils.formatDate(element.createdOn, DateUtils.FORMAT_DATETIME_AM_PM);
        });
        this.addDispatcherRequest.data = result;
    }

    private maskPhone(phone: string) {
        return CommonUtils.phoneNumberMask(phone);
    }

}
